import Vue from 'vue'
import { PageHeader, Table, Tabs, Form, Input, Select, Button, message, Spin, Modal } from 'ant-design-vue'

Vue.use(PageHeader)
Vue.use(Table)
Vue.use(Tabs)
Vue.use(Form)
Vue.use(Input)
Vue.use(Select)
Vue.use(Button)
Vue.use(Spin)
Vue.prototype.$message = message
Vue.prototype.$error = Modal.error
Vue.prototype.$info = Modal.info
